module.exports = __webpack_public_path__ + "static/img/inventario_tanques.d651213.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/inventario_tanques.png
// module id = 97
// module chunks = 0